import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "Actions";
import {Close} from "../../../components/utils/SvgIcons";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

class PhoneNumberForm extends Component {


  hitSmsApi = () => {
    const { email, phone, hitSmsApi } = this.props;
    hitSmsApi(email, phone)
  };

  render() {

    const { fieldChanged, phone, sendingSms, resetTwoFactor } = this.props;

    return (
      <div className="contentWrapperTwoFactor">
        <div className="content thin">
          <div className="container-header">
            <h4>Two-Factor Authentication</h4>
            <a onClick={resetTwoFactor}><Close/></a>
          </div>
          <p>Your login is being used to sign in to a new device.</p>
          <p>Enter your mobile phone number and TapGoods will text you a verification code:</p>
          <PhoneInput
            inputProps={ {
              name: 'phone',
              autoFocus: true
            } }
            country={ "us" }
            value={ phone }
            onChange={ phone => {
              fieldChanged( { field: "phone", text: phone } )
            } }
          />
          <div className="container-buttons">
            <button className={ sendingSms ? "btn fullWidth disabled" : "btn fullWidth" }
                    onClick={ () => {
                      this.hitSmsApi();
                    } }>
              { sendingSms ? 'Please wait...' : 'Send A Text Message' }
            </button>
            <button className="btn cancel" onClick={resetTwoFactor}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  const { errors, loading } = state.auth;
  return { errors, loading };
};

export default connect(mapStateToProps, actions)(PhoneNumberForm);